// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylesheets/body/collectionPage.styl
// module id = 420
// module chunks = 0